Vue.component('google-map', {
	delimiters: [ '[[', ']]' ],
	mixins: [ eventHubMixin ],
	props: {
		residences: Array,
		residence: null
	},
	data: () => {
		return {
			map: null,
			bounds: null,
			markers: [],
			ibOptions: {},
			ib: null,
			mapStyle: [
				// {
				// 	featureType: 'poi',
				// 	elementType: 'all',
				// 	stylers: [
				// 		{
				// 			visibility: 'off'
				// 		}
				// 	]
				// },
				{
					featureType: 'road.highway',
					elementType: 'labels.icon',
					stylers: [
						{
							visibility: 'off'
						}
					]
				},
				{
					featureType: 'road.highway.controlled_access',
					elementType: 'all',
					stylers: [
						{
							visibility: 'on'
						}
					]
				},
				{
					featureType: 'road.highway.controlled_access',
					elementType: 'labels.icon',
					stylers: [
						{
							visibility: 'off'
						}
					]
				},
				{
					featureType: 'road.arterial',
					elementType: 'labels.icon',
					stylers: [
						{
							visibility: 'off'
						}
					]
				},
				{
					featureType: 'road.local',
					elementType: 'labels.icon',
					stylers: [
						{
							visibility: 'off'
						}
					]
				},
				// {
				// 	featureType: 'transit',
				// 	elementType: 'all',
				// 	stylers: [
				// 		{
				// 			visibility: 'off'
				// 		}
				// 	]
				// }
			]
		};
	},
	methods: {
		getInfoWindowContent: function(marker, address) {
			// console.log('marker', marker)
			return `<div class="info-box-wrap">
            <div class="info-box-text-wrap">
              <a class="title pb-15" href="${marker.relative_url}">${marker.name}</a>
              <p>${address.number} ${address.street}</p>
              <p>${address.zipcode} ${address.city}</p>
              <a class="fw-medium c-primary" href="tel:${address.phone_number}">${address.phone_number}</a>
            </div>
            <a href="${marker.relative_url}" class="block image-container">
              <div class="image" style="background-image: url(${marker.images_obj[0].image_obj.rectangle_url})">
              </div>
            </a>
          </div>`;
		}
	},
	created: function() {},
	mounted: function() {
		window.GoogleMapsLoader.LANGUAGE = gettext('fr');
		window.GoogleMapsLoader.REGION = 'FR';
		window.GoogleMapsLoader.KEY = 'AIzaSyBQgqqlrnhnHCg579fUTUJ4dZIpax5SsUs';
		window.GoogleMapsLoader.VERSION = 'weekly';
		const mapCenter = this.residences[0].locations[0];
		const that = this;
		window.GoogleMapsLoader.load(function(google) {
			let infoboxScript = document.createElement('script');
			infoboxScript.setAttribute('src', window.site_url + '/static/js/lib/infobox_packed.js?v=1.0');
			document.head.appendChild(infoboxScript);
			infoboxScript.addEventListener('load', function() {
				setTimeout(() => {
					that.eventHub.$emit('google-maps:loaded');
				}, 100);
				that.ibOptions = {
					disableAutoPan: false,
					alignBottom: true,
					maxWidth: 0,
					pixelOffset: new google.maps.Size(-165, -20),
					zIndex: -1,
					boxStyle: {
						padding: '0px 0px 0px 0px',
						// width: "252px",
						height: '130px'
					},
					closeBoxURL: '',
					infoBoxClearance: new google.maps.Size(1, 1),
					isHidden: false,
					pane: 'overlayImage',
					// pane: "mapPane",
					enableEventPropagation: false
				};
				that.ib = new InfoBox(that.ibOptions);

				function CustomMarker(latlng, map, data, address) {
					this.latlng = latlng;
					this.data = data;
					this.address = address;
					this.map = map;
					this.setMap(map);
				}

				CustomMarker.prototype = new google.maps.OverlayView();

				CustomMarker.prototype.draw = function() {
					let self = this;

					let div = this.div;

					if (!div) {
						div = this.div = document.createElement('div');

                        if (this.data.in_construction) {
                            div.className = 'marker-yellow js-marker';
                        } else {
					        div.className = 'marker js-marker';
                        }
						// div.id = self.id;
						div.innerHTML = div.innerHTML + '<i class="icon icon-account-plain"></i>';

						if (typeof self.id !== 'undefined') {
							div.dataset.index = self.id;
						}
						let panes = this.getPanes();
						panes.overlayImage.appendChild(div);
						google.maps.event.addDomListener(div, 'mouseover', function() {
							// bus.$emit('openEvent', div);
						});
						google.maps.event.addDomListener(div, 'mouseout', function() {
							// bus.$emit('closeEvent', div);
						});
						google.maps.event.addDomListener(div, 'click', function() {
							// bus.$emit('clickEvent', div);
							that.eventHub.$emit('modal:map:open', div);
							[ ...document.querySelectorAll('.js-marker') ].forEach((el) =>
								el.style.removeProperty('z-index')
							);
							div.style.zIndex = 1;
							// console.log('test');
						});
						google.maps.event.addListener(self.map, 'click', function(event) {
							// console.log('click map');
							if (that.ib) {
								that.ib.close();
								[ ...document.querySelectorAll('.js-marker') ].forEach((el) =>
									el.classList.remove('hover')
								);
							}
						});
						google.maps.event.addDomListener(div, 'click', function(event) {
							event.stopPropagation();
							// console.log(self.data.id);
							// console.log(that.getInfoWindowContent(self.data, self.address));
							if (that.ib) {
								that.ib.close();
								[ ...document.querySelectorAll('.js-marker') ].forEach((el) =>
									el.classList.remove('hover')
								);
							}
							if (!div.classList.contains('hover')) {
								// console.log(div.classList);
								let boxText = document.createElement('div');
								boxText.style.cssText = 'height: 100%; background: #fff; padding: 0px;';
								boxText.innerHTML = that.getInfoWindowContent(self.data, self.address);
								// console.log(boxText);
								div.classList.add('hover');
								that.ib.setContent(boxText);
								// ibOptions.content = boxText

								that.ib.open(self.map, self);
							}
							self.map.panTo(that.ib.getPosition());
						});
					}

					let point = this.getProjection().fromLatLngToDivPixel(this.latlng);

					if (point) {
						div.style.left = point.x - 15 + 'px';
						div.style.top = point.y - 37 + 'px';
					}
					this.div = div;
				};

				CustomMarker.prototype.remove = function() {
					if (this.div) {
						bus.$off('openEvent', this.div);
						bus.$off('closeEvent', this.div);
						bus.$off('clickEvent', this.div);
						google.maps.event.clearInstanceListeners(this.div);
						this.div.parentNode.removeChild(this.div);
						this.div = null;
					}
				};

				CustomMarker.prototype.getPosition = function() {
					return this.latlng;
				};

				CustomMarker.prototype.getElement = function() {
					return this.div;
				};

				let options = {
					zoom: 14,
					maxZoom: 18,
					center: new google.maps.LatLng(mapCenter[0], mapCenter[1]),
					styles: that.mapStyle
				};
				that.map = new google.maps.Map(document.getElementById('map'), options);
				var transitLayer = new google.maps.TransitLayer();
				transitLayer.setMap(that.map);
				that.bounds = new google.maps.LatLngBounds();

				that.residences.forEach((residence) => {
					residence.locations.forEach((location, index) => {
						// console.log();
						const position = new google.maps.LatLng(location[0], location[1]);
						const marker = new CustomMarker(position, that.map, residence, residence.addresses_obj[index]);
						that.markers.push(marker);
						if (!that.residence) {
							that.bounds.extend(position);
						} else if (residence.id === that.residence) {
							that.bounds.extend(position);
							if (window.site_id === 2) {
								setTimeout(() => {
									if (that.ib) {
										that.ib.close();
										[ ...document.querySelectorAll('.js-marker') ].forEach((el) =>
											el.classList.remove('hover')
										);
									}
									if (!marker.div.classList.contains('hover')) {
										let boxText = document.createElement('div');
										boxText.style.cssText = 'height: 100%; background: #fff; padding: 0px;';
										boxText.innerHTML = that.getInfoWindowContent(marker.data, marker.address);
										marker.div.classList.add('hover');
										that.ib.setContent(boxText);
										that.ib.open(marker.map, marker);
									}
									marker.map.panTo(that.ib.getPosition());
								}, 100);
							}
						}
					});
				});
				if (that.residences.length > 1) {
                    // console.log(that.residences.length);
					that.map.fitBounds(that.bounds, 50);
				}
			});
		});
	},
	template: `<div id="map" ref="map" class="js-map" data-lat="48.866667" data-lng="2.333333">
</div>`
});
